"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedParticipantResponse = exports.mockedParticipantCreateOrUpdateRequest = void 0;
const date_util_1 = require("../../utils/date.util");
exports.mockedParticipantCreateOrUpdateRequest = {
  firstName: 'participant first name',
  lastName: 'participant last name',
  email: 'participant@email.com'
};
exports.mockedParticipantResponse = {
  id: 1,
  firstName: 'participant first name',
  lastName: 'participant last name',
  email: 'participant@email.com',
  isEmailVerified: false,
  phone: null,
  country: null,
  city: null,
  birthDay: null,
  gender: null,
  seller: null,
  signupDate: null,
  joinedDate: null,
  isActive: true,
  isDeleted: false,
  createdAt: date_util_1.takeDaysFromNow(),
  updatedAt: null,
  weight: 0,
  targetWeight: 0,
  height: 0,
  nutritionalLimitations: '',
  trainingLimitations: '',
  facebook: '',
  instagram: '',
  amoId: '',
  neId: '',
  postalCode: '',
  address: ''
};